/* Midnight London — global theme JS */
(function(){
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* header scroll state (homepage starts transparent; other pages are .solid) */
  var header = document.getElementById('header');
  if(header){
    var onScroll = function(){
      if(window.scrollY > 40){ header.classList.add('scrolled'); }
      else { header.classList.remove('scrolled'); }
    };
    window.addEventListener('scroll', onScroll, { passive:true });
    onScroll();
  }

  /* announcement rotator */
  var msgs = document.querySelectorAll('.announce__msg');
  var ai = 0;
  if(msgs.length > 1 && !prefersReduced){
    setInterval(function(){
      msgs[ai].classList.remove('is-active');
      ai = (ai + 1) % msgs.length;
      msgs[ai].classList.add('is-active');
    }, 4200);
  }

  /* overlay helpers */
  var scrim = document.getElementById('scrim');
  var cart = document.getElementById('cartDrawer');
  var menu = document.getElementById('mobileMenu');
  var search = document.getElementById('search');
  function openEl(el){
    if(!el) return;
    el.classList.add('open'); el.setAttribute('aria-hidden','false');
    if(scrim) scrim.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeAll(){
    [cart, menu, search].forEach(function(e){
      if(e){ e.classList.remove('open'); e.setAttribute('aria-hidden','true'); }
    });
    if(scrim) scrim.classList.remove('open');
    document.body.style.overflow = '';
  }
  function on(id, fn){ var el = document.getElementById(id); if(el) el.addEventListener('click', fn); }
  on('cartOpen', function(){ openEl(cart); });
  on('cartClose', closeAll);
  on('cartShop', closeAll);
  on('menuOpen', function(){ openEl(menu); });
  on('menuClose', closeAll);
  on('searchOpen', function(){
    openEl(search);
    var i = document.getElementById('searchInput');
    setTimeout(function(){ if(i) i.focus(); }, 300);
  });
  on('searchClose', closeAll);
  if(scrim) scrim.addEventListener('click', closeAll);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeAll(); });

  /* scroll reveal */
  var reveals = document.querySelectorAll('.reveal');
  if(prefersReduced || !('IntersectionObserver' in window)){
    reveals.forEach(function(r){ r.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold:0.12, rootMargin:'0px 0px -8% 0px' });
    reveals.forEach(function(r){ io.observe(r); });
  }

  /* collection sort */
  var sortSel = document.getElementById('SortBy');
  if(sortSel){
    sortSel.addEventListener('change', function(){
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSel.value);
      window.location.href = url.toString();
    });
  }

  /* ---- cart (AJAX) ---- */
  function updateCount(count){
    var c1 = document.getElementById('cartCount');
    var c2 = document.getElementById('cartDrawerCount');
    if(c1) c1.textContent = count;
    if(c2) c2.textContent = count;
  }

  function refreshDrawer(openAfter){
    fetch('/?sections=header')
      .then(function(r){ return r.json(); })
      .then(function(data){
        var html = data.header;
        if(!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var newBody = tmp.querySelector('#cartBody');
        var newFoot = tmp.querySelector('#cartDrawer .drawer__foot');
        var newCount = tmp.querySelector('#cartDrawerCount');
        if(newBody && cart){
          cart.querySelector('#cartBody').innerHTML = newBody.innerHTML;
          cart.querySelector('.drawer__foot').innerHTML = newFoot.innerHTML;
        }
        if(newCount) updateCount(newCount.textContent.trim());
        if(openAfter) openEl(cart);
      })
      .catch(function(){ if(openAfter) window.location.href = '/cart'; });
  }

  /* quantity buttons in drawer (delegated — drawer HTML is replaced after updates) */
  if(cart){
    cart.addEventListener('click', function(e){
      var btn = e.target.closest('[data-line-change]');
      if(!btn) return;
      e.preventDefault();
      fetch('/cart/change.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json' },
        body: JSON.stringify({ line: parseInt(btn.getAttribute('data-line-change'), 10), quantity: parseInt(btn.getAttribute('data-qty'), 10) })
      }).then(function(){ refreshDrawer(false); });
    });
  }

  /* product form: AJAX add to cart */
  var productForm = document.getElementById('productForm');
  if(productForm){
    productForm.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = document.getElementById('addToCart');
      var note = document.getElementById('addNote');
      btn.disabled = true;
      fetch('/cart/add.js', { method:'POST', body: new FormData(productForm) })
        .then(function(r){
          if(!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function(){
          btn.disabled = false;
          if(note) note.textContent = '';
          refreshDrawer(true);
        })
        .catch(function(){
          btn.disabled = false;
          if(note) note.textContent = 'Could not add this piece — please try again.';
        });
    });
  }

  /* product variant picker */
  var variants = window.__productVariants;
  var selects = document.querySelectorAll('.pdp__select[data-option-position]');
  if(variants && selects.length){
    var priceEl = document.getElementById('pdpPrice');
    var idInput = document.getElementById('variantId');
    var addBtn = document.getElementById('addToCart');
    function money(cents){
      var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
      return '£' + amount;
    }
    function syncVariant(){
      var chosen = [];
      selects.forEach(function(s){ chosen[parseInt(s.getAttribute('data-option-position'),10) - 1] = s.value; });
      var match = null;
      for(var i = 0; i < variants.length; i++){
        var v = variants[i];
        var ok = true;
        for(var j = 0; j < chosen.length; j++){
          if(v.options[j] !== chosen[j]){ ok = false; break; }
        }
        if(ok){ match = v; break; }
      }
      if(match){
        idInput.value = match.id;
        if(priceEl){
          if(match.compare_at_price && match.compare_at_price > match.price){
            priceEl.innerHTML = '<del>' + money(match.compare_at_price) + '</del><span class="sale">' + money(match.price) + '</span>';
          } else {
            priceEl.textContent = money(match.price);
          }
        }
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
      } else {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
      }
    }
    selects.forEach(function(s){ s.addEventListener('change', syncVariant); });
  }

  /* hero video */
  var v = document.querySelector('video.hero__video');
  if(v){
    var show = function(){ v.classList.add('is-playing'); v.play().catch(function(){}); };
    if(v.readyState >= 3){ show(); } else { v.addEventListener('canplay', show, { once:true }); }
  }
})();
